import { FormattedMessage } from "react-intl";
import AnnouncementIcon from "../../../components/Common/SvgIcons/SocialIcons/AnnouncementIcon";
import ForumAreaIcon from "../../../components/Common/SvgIcons/SocialIcons/ForumAreaIcon";
import ModerateContributionsIcon from "../../../components/Common/SvgIcons/SocialIcons/ModerateContributionsIcon";
import PollManagementIcon from "../../../components/Common/SvgIcons/SocialIcons/PollManagementIcon";
import { roleMenuList } from "../../roleMenuList";
import { featureList } from "../../featureList";

export const social = {
  name: "Social Connect",
  // path: `/${localStorage.getItem("tenantName")}/social`,
  path: (tenantName) => `/${tenantName}/social`,
  tiles: (navigate, tenantName) => [
    {
      key: 1,
      label: <FormattedMessage id="Poll_Management" />,
      color: "#43E57A",
      path: `/${tenantName}/social/pollManagement`,
      onClick: () => navigate(`/${tenantName}/social/pollManagement`),
      icon: (fill) => <PollManagementIcon fill={fill} />,
      isVisible: true,
      // name: [roleMenuList?.SOCIAL?.POLL_MANAGEMENT],
      // feature: [featureList?.POLL],
      feature: [
        {
          roleMenu: roleMenuList?.SOCIAL?.POLL_MANAGEMENT,
          MSOMMenu: featureList?.POLL,
        },
      ],
    },
    {
      key: 2,
      label: "Forum Area",
      color: "#A07EFF",
      path: `/${tenantName}/social/forumArea`,
      onClick: () => navigate(`/${tenantName}/social/forumArea`),
      icon: (fill) => <ForumAreaIcon fill={fill} />,
      isVisible: true,
      // name: [roleMenuList?.SOCIAL?.FORUM_AREA],
      // feature: [featureList?.FORUM],
      feature: [
        {
          roleMenu: roleMenuList?.SOCIAL?.FORUM_AREA,
          MSOMMenu: featureList?.FORUM,
        },
      ],
    },
    {
      key: 3,
      label: "Moderate Contributions",
      color: "#FF7EB5",
      path: `/${tenantName}/social/moderateContributions`,
      onClick: () =>
        navigate(`/${tenantName}/social/moderateContributions/submissions`),
      icon: (fill) => <ModerateContributionsIcon fill={fill} />,
      isVisible: true,
      name: [roleMenuList?.SOCIAL?.MODERATE_CONTRIBUTION],
      feature: [
        {
          roleMenu: roleMenuList?.SOCIAL?.MODERATE_CONTRIBUTION,
          MSOMMenu: featureList?.MODERATE_CONTRIBUTION,
        },
      ],
    },
    // {
    //   key: 4,
    //   label: "Announcement",
    //   color: "#7EBEFF",
    //   path: `/${tenantName}/social/announcement`,
    //   onClick: () => navigate(`${social.path}/announcement`),
    //   icon: (fill) => <AnnouncementIcon fill={fill} />,
    // },
  ],
};
